export const GET_PAYMENT_LINK = 'GET_PAYMENT_LINK';
export const SET_PAYMENT_LINK = 'SET_PAYMENT_LINK';
export const CREATE_PAYMENT_LINK = 'CREATE_PAYMENT_LINK';
export const CHECK_PAYMENT_LINK_AVAILABLE = 'CHECK_PAYMENT_LINK_AVAILABLE';
export const SET_PAYMENT_LINK_AVAILABLE = 'SET_PAYMENT_LINK_AVAILABLE';
export const GET_SINGLE_PAYMENT_LINK = 'GET_SINGLE_PAYMENT_LINK';
export const SET_SINGLE_PAYMENT_LINK = 'SET_SINGLE_PAYMENT_LINK';
export const EDIT_SINGLE_PAYMENT_LINK = 'EDIT_SINGLE_PAYMENT_LINK';

export const DELETE_SINGLE_PAYMENT_LINK = 'DELETE_SINGLE_PAYMENT_LINK';

export const PUBLISH_LINK = 'PUBLISH_LINK';
export const PUBLISH_LINK_SUCCESS = 'PUBLISH_LINK_SUCCESS';
export const PUBLISH_LINK_FAILURE = 'PUBLISH_LINK_FAILURE'

export const GET_PLAN_LNK = 'GET_PLAN_LINK';
export const SET_PLAN_LINK = 'SET_PLAN_LINK';
export const GET_LINK_TRANSACTIONS = 'GET_LINK_TRANSACTIONS';
export const SET_LINK_TRANSACTIONS = 'SET_LINK_TRANSACTIONS';
